import { motion, useMotionValue, useReducedMotion, useSpring } from "framer-motion";
import type { AnchorHTMLAttributes, ReactNode } from "react";

/** CTA that leans a few pixels toward the cursor (mouse only, never on touch). */
export const MagneticLink = ({ children, strength = 6, ...rest }: { children: ReactNode; strength?: number } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "onDrag" | "onDragStart" | "onDragEnd" | "onAnimationStart">) => {
  const reduce = useReducedMotion();
  const x = useSpring(useMotionValue(0), { stiffness: 220, damping: 18 });
  const y = useSpring(useMotionValue(0), { stiffness: 220, damping: 18 });
  const move = (e: React.PointerEvent<HTMLAnchorElement>) => {
    if (reduce || e.pointerType !== "mouse") return;
    const r = e.currentTarget.getBoundingClientRect();
    x.set(((e.clientX - r.left) / r.width - 0.5) * strength * 2);
    y.set(((e.clientY - r.top) / r.height - 0.5) * strength * 2);
  };
  const leave = () => { x.set(0); y.set(0); };
  return (
    <motion.a {...rest} style={{ x, y }} onPointerMove={move} onPointerLeave={leave} whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
      {children}
    </motion.a>
  );
};
